<template>
	<v-dialog persistent v-model="dialog" width="800px">
		<v-card style="padding:0 24px;">
			<v-card-title>
			</v-card-title>
			<v-card-text style="border:1px solid #ccc;border-radius:5px;">
				<div id="printme4ssr">
					<div style="display:flex;justify-content:center;">
						<div>
							<img src='/huasanlogo_v.png' width="80"/>
						</div>
					</div>
					<div style="margin-top:48px;text-align:center;font-size:28px;font-weight:bold;" >
						复检提醒
					</div>
					<div style="margin-top:64px;color:#333;line-height:32px;" >
						<div>尊敬的{{s1}}，</div>
						<div>
							您于{{s2}}在华三消化内镜中心{{item && item.region}}诊所行{{item && item.opts.GIE}}检查，
							检查结果为{{s6}}{{s7}}{{s8}}
						</div>
						<div>
							根据检查结果，医生建议您在{{s4}}{{s5}}。
						</div>
						<div>
							定期复查是预防及治疗消化道疾病的重要环节，为持续守护您的胃肠道健康，请您联系您的健康顾问或华三啄木鸟官方客服，协助办理相关事宜。
						</div>
						<div style="margin-top:144px;margin-right:36px;text-align:right;font-weight:bold;">华三消化内镜中心  啄木鸟客服</div>
						<div style="margin-top:16px;margin-right:36px;text-align:right;font-weight:bold;">{{s3}}</div>
					</div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="primary" v-print="printObj" @click.stop="setNow" :loading="saving" :disabled="saving">打印</v-btn>
				<v-btn @click.stop="exitDlg">返回</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import print from 'vue-print-nb'
	import {formatDate, formatTime, addMonths} from '../utils'

	export default {
		name: 'SubsequentReminder',
		directives: {
			print   
		},
		props: {
			value: false,
			item: {},
		},
		data() {
			return {
				saving: false,
				now: '',
				printObj: {
					id: 'printme4ssr',
					popTitle: '复检提醒',
					beforeOpenCallback(vue) {
						return false;
					},
					openCallback(vue) {
						vue.save();
					}
				}
			}
		},
		computed: {
			dialog: {
				get() {
					return this.value;
				},
				set(v) {
					if (!v) {
						this.$emit('input', false);
					}
				}
			},
			s1() {
				if (!this.item) return '';
				return this.item.pii.username + (this.item.pii.gender === '男' ? '先生' : '女士');
			},
			s2() {
				if (!this.item) return '';
				return formatDate(this.item.progress.operative);
			},
			s3() {
				return formatDate(new Date());
			},
			s4() {
				if (!this.item?.subsequent?.estTimew) return '';
				return formatDate(this.item.subsequent.estTimew) + '前进行胃镜复查' + (this.item?.subsequent?.estTimec ? '；' : '');
			},
			s5() {
				if (!this.item?.subsequent?.estTimec) return '';
				return formatDate(this.item.subsequent.estTimec) + '前进行肠镜复查';
			},
			s6() {
				if (!this.item?.reports) return '';
				const rpt = this.item.reports;
				let rs = '';
				if (rpt['胃镜']?.diagnoses) rs += rpt['胃镜']?.diagnoses + (rpt['肠镜']?.diagnoses ? '；' : '');
				if (rpt['肠镜']?.diagnoses) rs += rpt['肠镜']?.diagnoses;
				rs += '。';
				return rs;
			},
			s7() {
				if (!this.item?.pathologyDiagnosisW) return '';
				return '胃镜病理结果为' + this.item.pathologyDiagnosisW;
			},
			s8() {
				if (!this.item?.pathologyDiagnosisC) return '';
				return '肠镜病理结果为' + this.item.pathologyDiagnosisC;
			},
		},
		watch: {
			value(v) {
				if (v) {
				}
			}
		},
		methods: {
			exitDlg() {
				this.dialog = false;
				this.$emit('close');
			},
			setNow() {
				this.now = `[ ${formatTime(new Date())} ]`;
			},
			async save() {

			},
		},
	}
</script>

<style>
#printme4ssr {
	position:relative;
	height:1040px;
	font-size:18px;
	padding:0 24px;
}
</style>
